import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Platform } from '@angular/cdk/platform';
import { Router } from '@angular/router';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File as FileI } from '@ionic-native/file/ngx';
import { HandlerService } from '../handler.service';
import { Diagnostic as Diagnostics } from '@ionic-native/diagnostic/ngx';
declare let html2canvas: any;
@Component({
  selector: 'app-reward-details',
  templateUrl: './reward-details.component.html',
  styleUrls: ['./reward-details.component.scss'],
})
export class RewardDetailsComponent {
  loader: boolean; id;
  item: any;
  pic;
  userObj: any;
  back:boolean=false;
  orgObj: any;
  address: any;
  content;
  constructor(public service: ApiService,
    private diagnostic: Diagnostics,
    private platform: Platform,
    public file: FileI,
    private router:Router,
    private fileOpener: FileOpener,
    public handler: HandlerService) {
     }

  ionViewWillEnter() {
    this.id = window.location.href.split('/').pop();
    this.loader = true;
    this.service.getAdById(this.id).subscribe((res: any) => {
      this.item = res;
      this.content = res.content;
      if (this.item.documentId) {
        this.service.getImage(res.documentId).subscribe(res => {
          if (this.item.type == 1) {
            this.pic = 'image';
            let binary = new Uint8Array(res)
            let blob = new Blob([binary], { type: 'image/gif' });
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = (res: any) => {
              this.pic = res.target.result
              this.loader = false;
            }
          }
        })
        this.service.getOrgAddressById(res.orgId).subscribe((res: any) => {
          this.orgObj = res;
          this.address = res.addresses.filter(res => { return res.type == 1 })
          this.address = this.address[0];
        }, err => {
          this.loader = false;
          this.handler.err(err)
        })
      }
      else {
        this.loader = false;
      }
    }, err => {
      this.loader = false;
      this.handler.err(err)
    });
    this.service.getUserById(localStorage.getItem('currentUserId')).subscribe((res: any) => {
      this.userObj = res
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }
  async generatePdf() {
    let blob;
    let date1 = new Date();
    let date = date1.getDate();
    let month = date1.getMonth() + 1;
    let year = date1.getFullYear();
    let pass = date + '-' + month + '-' + year;
    let x = document.getElementById('card');
    document.body.appendChild(x);
    x.setAttribute('style', 'visibility:visible !important');
    html2canvas(document.querySelector("#card")).then(canvas => {
      var link = document.createElement('a');
      if (this.platform.isBrowser) {
        link.download = "Coupon-" + pass + '.png';
        link.href = canvas.toDataURL()
        link.click();
        x.remove();
        this.ionViewWillEnter()
      }
      else {
        fetch(canvas.toDataURL()).then(res => {
          res.blob().then(res1 => {
            blob = res1;
            this.diagnostic.requestCameraAuthorization().then(res => {
              this.file.writeFile(this.file.cacheDirectory, "Coupon-" + pass + '.png', blob, { replace: true }).then(res => {
                var url = res.nativeURL;
                this.fileOpener.open(url, 'image/png')
                  .then(() =>{
                    window.location.reload();
                  })
                  .catch(e =>{});
              })
            })
          })
        })
      }
    })
  }
 
  
}
